/**
 * US-115 / SCRUM-156: shared constant for the medication_lookup dropdown.
 *
 * The "no current medications" sentinel is a selectable option so a resident
 * with no active meds is still recordable AND a required field stays
 * satisfiable. It's defined here (not inline) so both the host that builds the
 * options (ResidentFormFillModal) and the renderer that reconciles selections
 * (FieldRenderer) agree on the exact value.
 */
export const NO_CURRENT_MEDS = "None — no current medications";

/**
 * Reconcile a medication_lookup multi-select value so "none" and real meds are
 * never selected together. Mantine appends newly-picked items to the end, so:
 *  - if "none" was just added (it's last) → collapse to just ["none"]
 *  - otherwise (a real med is present) → drop "none"
 */
export function reconcileMedicationSelection(next: string[]): string[] {
  if (!next.includes(NO_CURRENT_MEDS) || next.length <= 1) return next;
  if (next[next.length - 1] === NO_CURRENT_MEDS) return [NO_CURRENT_MEDS];
  return next.filter((v) => v !== NO_CURRENT_MEDS);
}
